import { render } from "./CardHolder.vue?vue&type=template&id=7f3c7103"
import script from "./CardHolder.vue?vue&type=script&lang=js"
export * from "./CardHolder.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__